import { ConfigProps } from '@config/types'

const config = ({ sportApiUrl }: ConfigProps) => ({
  baseUrl: sportApiUrl,
  livecenterUrl: '/sport/alle-liveticker-id15000271.html',
  eventUrlTemplate: '/de/live-event/{SPORT}/{EVENT_ID}',
  eventUrlTemplate___romandie: '/fr/live-event/{SPORT}/{EVENT_ID}',
  standingsUrlTemplate: '/de/standings/{SPORT}/{EVENT_ID}',
  standingsUrlTemplate___romandie: '/fr/standings/{SPORT}/{EVENT_ID}',
  sporttipUrl:
    'https://www.swisslos.ch/de/sporttip/sportwetten/wetten.html?utm_campaign=sporttip-blicklivecenter&utm_medium=display&utm_source=blick',
  sporttipLiveUrl:
    'https://www.swisslos.ch/de/sporttip/sportwetten/wetten.html?utm_medium=kooperation&utm_source=blick&utm_campaign=sporttip-kooperation-blick-liveticker-de&utm_content=spezintegration#/live',
})

export type configType = ReturnType<typeof config>
export default config
